@if (mediaLockableRepository.revealed()) {
  <div class="container" [class.limit-portrait-width-on-desktop]="mediaLockableRepository.limitPortraitWidthOnDesktop()">
    @if (mediaLockableRepository.media(); as media) {
      <!-- Pointer access is removed once the media starts playing so the lock cannot be paused -->
      <app-media
        class="media"
        [class.disable-pointer]="mediaLockableRepository.initialized()"
        [config]="media"
        (playing)="onMediaPlaying()"
        (currentTime)="onMediaCurrentTime($event)"
        (duration)="onMediaDuration($event)"
        (error)="onMediaError()"
        (isPortrait)="onMediaIsPortrait($event)"
      />
    }
    <!-- Display a Progress Bar representing how long the UI is locked for -->
    @if (mediaLockableRepository.shouldDisplayProgress()) {
      <mat-progress-bar
        class="progress disable-pointer"
        [class.hide-progress]="!mediaLockableRepository.initialized()"
        mode="determinate"
        [value]="mediaLockableRepository.progress()"
      />
    }
  </div>
}
